import { render, staticRenderFns } from "./AdministratorsComponent.vue?vue&type=template&id=d1029470&"
import script from "./AdministratorsComponent.vue?vue&type=script&lang=js&"
export * from "./AdministratorsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports